import axios from "axios";

const getPartnersMDAuth = () => {
  try {
    const mdauth = JSON.parse(window.localStorage.getItem("partners-md-auth"));
    return mdauth;
  } catch (error) {
    return {};
  }
};

export const api_request = () => {
  try {
    const mdauth = getPartnersMDAuth();
    if (!mdauth) window.location.href = "/";
    const _axios = new axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}/partners`,
      timeout: 60000,
      headers: {
        user: mdauth?.user,
        token: mdauth?.token,
        "Content-Type": "application/json",
      },
    });
    //axiosRetry(_axios, { retries: 3, shouldResetTimeout: true });
    return _axios;
  } catch (error) {
    console.log("AxiosAPIRequest Error", error);
    return null;
  }
};

export const checkAuth = (resp) => {
  const mdauth = JSON.parse(window.localStorage.getItem("partners-md-auth"));
  if (!mdauth) return;
  if (resp.status === 401) {
    window.localStorage.removeItem("partners-md-auth");
    return;
  }
};
